import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';

// app: components
import Tabs from 'components/Tabs';

// app: services
import { isApp } from 'services/environment';

// app: queries
import GetCategoryTabsQuery from './GetCategoryTabsQuery.gql';

function CategoryTabs(props) {
  const { id, selected, className, ariaLabel, urlBuilder } = props;

  const { previousData, data } = useQuery(GetCategoryTabsQuery, {
    variables: {
      id: 'books',
    },
    fetchPolicy: isApp() ? 'cache-and-network' : 'cache-first',
    errorPolicy: 'all',
  });

  const tabs = data?.Categories || previousData?.Categories || [];
  return (
    <Tabs
      className={className}
      selected={selected}
      options={tabs.filter(_tab => !_tab.hide || _tab.id === selected).map(_tab => ({
        id: _tab.id,
        label: _tab.title,
        href: urlBuilder(_tab),
      }))}
      ariaLabel={ariaLabel}
      idPrefix={id}
    />
  );
}

CategoryTabs.propTypes = {
  id: PropTypes.string,
  selected: PropTypes.string,
  className: PropTypes.string,
  ariaLabel: PropTypes.string,
  urlBuilder: PropTypes.func,
};

CategoryTabs.defaultProps = {
  id: null,
  selected: null,
  className: null,
  ariaLabel: null,
  urlBuilder: () => null,
};

export default CategoryTabs;
